import { useQuery } from '@tanstack/react-query';
import { permissionDemoApi } from '../api/permissionDemoApi';
import type { SimulateResponse, ApiError } from '../types/permissionDemo';

/**
 * Query: GET /api/eraf/permission-demo/simulate?role=<role>
 * Only fires when role is non-empty (enabled flag).
 * 400 = unknown role code — surface as ErrorState in simulator panel.
 */
export function useSimulate(role: string | null) {
  return useQuery<SimulateResponse, ApiError>({
    queryKey: ['permission-demo', 'simulate', role],
    queryFn: () => permissionDemoApi.simulate(role!),
    enabled: !!role,
    retry: false,
    staleTime: 60_000,
  });
}
